import React from 'react'
import TaskCreationStep from '../Steps/SubtaskCreationStep'
import TaskSettingStep from '../Steps/TaskSettingStep'
import TimeFrameSelection from '../Steps/TimeFrameSelection'
import { StepType, useFormStepContext } from '../FormStepContext'
import AIPromptStep from 'components/TasksV2/AITaskCreation/components/AIPromptStep'
import AISubtaskStep from 'components/TasksV2/AITaskCreation/components/AISubtaskStep'
import PromptGeneratorStep from 'components/TasksV2/AITaskCreation/components/PromptGeneratorStep'
import { AIStepType } from 'components/TasksV2/AITaskCreation/AIFormStepContext'
import { useVmAiEnhance } from '../hooks/useVmAiEnhance'
import { AI_SUBTASK_DRAFT_SLICE } from 'components/TasksV2/AITaskCreation/hooks/useAiSubtaskDraft'
import { SlideInPanel, useStepDirection } from 'components/TasksV2/UI/SlideInPanel'

export const Content: React.FC<{ titleSlot?: HTMLDivElement | null }> = ({ titleSlot }) => {
  const { stepStack } = useFormStepContext()
  const { handlePromptNext, handleDone } = useVmAiEnhance()

  const currentStep = stepStack[stepStack.length - 1]

  // The stack depth IS the direction: steps are pushed going forward and popped going back.
  const { direction, hasNavigated } = useStepDirection(stepStack.length)

  return (
    <SlideInPanel
      key={currentStep}
      direction={direction}
      isEnabled={hasNavigated}
      grow={currentStep === StepType.SUBTASK_TASK_CREATION || currentStep === StepType.TASK_SETTINGS}
    >
      {currentStep === StepType.SUBTASK_TASK_CREATION && <TaskCreationStep dualView headerSlot={titleSlot} />}
      {currentStep === StepType.TASK_SETTINGS && <TaskSettingStep dualView headerSlot={titleSlot} />}
      {currentStep === StepType.TIME_FRAME_SELECTION && <TimeFrameSelection />}

      {/* AI enhancement sub-flow for a single subtask — same steps as AI task creation */}
      {currentStep === AIStepType.AI_PROMPT && <AIPromptStep onNext={handlePromptNext} />}
      {currentStep === AIStepType.AI_PROMPT_GENERATOR && <PromptGeneratorStep />}
      {currentStep === AIStepType.AI_SUBTASK && (
        <AISubtaskStep
          draftKey={AI_SUBTASK_DRAFT_SLICE}
          showSummary={false}
          showTaskTitle={false}
          onDone={handleDone}
        />
      )}
    </SlideInPanel>
  )
}
